import Container from 'typedi';
import VehicleRepository from '../repositories/VehicleRepository';
class VehicleService {
  VehicleRepository;
  constructor() {
    this.VehicleRepository = Container.get(VehicleRepository);
  }
  getVehicles = async () => await this.VehicleRepository.getVehicles();
}

Container.set({ id: VehicleService, type: VehicleService });

export default VehicleService;
